module.exports = __webpack_public_path__ + "static/media/keys_big.95df3a10.svg";